import { render } from "./search-products.vue?vue&type=template&id=fda06288"
import script from "./search-products.vue?vue&type=script&lang=js"
export * from "./search-products.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__